import Bookmark from "@untitled-ui/icons-react/build/esm/Bookmark";
import FilterLines from "@untitled-ui/icons-react/build/esm/FilterLines";
import SearchSm from "@untitled-ui/icons-react/build/esm/SearchSm";
import { useCallback, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  doSearch,
  SEARCH_TYPES,
  setSearchType,
} from "../../../../store/reducer/_searchReducer";
import {
  addError,
  showFilterModal,
} from "../../../../store/reducer/_uiReducer";
import {
  getAppliedFilters,
  getCurrentModelTypeAppliedFilters,
  getCurrentSearchPeriod,
  getPageTitle,
  getQueryValue,
  getSearchModelType,
  getSearchType,
  getSelectedPersonFilter,
} from "../../../../store/selectors";
import { ErrorMessage } from "../../../../utils/classes";
import { PDLButton } from "../../dna";
import "./index.scss";

const OmniBar = ({ headerClass = null, isMobile = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const searchType = useSelector(getSearchType);
  const pageTitle = useSelector(getPageTitle);
  const currentQueryValue = useSelector(getQueryValue);
  const appliedFilters = useSelector(getAppliedFilters);
  const modalTypeAppliedFilters = useSelector(
    getCurrentModelTypeAppliedFilters
  );
  const appliedModelType = useSelector(getSearchModelType);
  const currentPeriod = useSelector(getCurrentSearchPeriod);
  const selectedPersonFilter = useSelector(getSelectedPersonFilter);

  const [queryValue, setQueryValue] = useState(currentQueryValue);

  const handleDDChange = useCallback(
    (value) => {
      dispatch(setSearchType(value));
    },
    [dispatch]
  );

  const handleInputChange = useCallback(
    ({ target: { value = null } = {} }) => setQueryValue(value),
    [setQueryValue]
  );

  const handleSearch = useCallback(() => {
    if (queryValue?.length > 5) {
      dispatch(doSearch({ query: queryValue, searchType }));
      navigate("/resultados");
    } else {
      const errorMessage = new ErrorMessage({
        message: "A pesquisa deve conter mais de 5 caracteres.",
        title: "Pesquisa Inválida",
        variant: "warning",
      });
      dispatch(addError(errorMessage));
    }
  }, [dispatch, navigate, queryValue, searchType]);

  const toggleFilterModal = useCallback(() => {
    dispatch(showFilterModal());
  }, [dispatch]);

  const renderSearchType = useCallback(() => searchType?.title, [searchType]);
  const currentSearchType = searchType.id;
  const currentAppliedFilterValues =
    appliedFilters[currentSearchType]?.flatMap((filter) => filter.values) ?? [];

  const modalTypeFilterCount =
    currentSearchType !== "modelos" || appliedModelType === "all"
      ? 0
      : modalTypeAppliedFilters.length + 1;

  const filterCount =
    currentAppliedFilterValues.length +
    (currentPeriod?.period && currentPeriod?.period !== "always" ? 1 : 0) +
    (selectedPersonFilter?.length > 2 ? 1 : 0) +
    modalTypeFilterCount;

  return (
    <div className="pdl_component_omnibar w-100">
      {headerClass !== "home" && (
        <>
          {!isMobile && (
            <div className="header-filter-container d-flex flex-row align-items-center justify-contents-between gap-3">
              <InputGroup>
                <DropdownButton
                  variant="outline-secondary"
                  title={renderSearchType()}
                  id="input-group-dropdown-1"
                >
                  {Object.entries(SEARCH_TYPES)
                    .sort(({ order: a }, { order: b }) => a - b)
                    .map(([id, { title }]) => (
                      <Dropdown.Item
                        href="#"
                        key={`DD_ITEM_${title}`}
                        onClick={() => handleDDChange(id)}
                      >
                        {title}
                      </Dropdown.Item>
                    ))}
                </DropdownButton>
                <Form.Control
                  type="text"
                  placeholder={
                    (pageTitle && `Pesquisar ${pageTitle}`) || "Plataforma LEX"
                  }
                  value={queryValue || ""}
                  onChange={handleInputChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearch();
                    }
                  }}
                />
                <PDLButton
                  variant="tertiary"
                  className="gray px-3"
                  onClick={handleSearch}
                >
                  <SearchSm />
                </PDLButton>
              </InputGroup>

              <div className="filter-buttons-container d-flex flex-row align-items-center gap-3">
                <PDLButton
                  variant="primary"
                  onClick={toggleFilterModal}
                  disabled={searchType.id === "all"}
                >
                  <FilterLines />
                  <span className="filter">
                    <p>Filtros</p>
                    {filterCount > 0 && (
                      <p className="count-box">{filterCount}</p>
                    )}
                  </span>
                </PDLButton>
                <PDLButton variant="secondary">
                  <Bookmark />
                  <span className="d-none d-sm-block">
                    &nbsp;Salvar&nbsp;Pesquisa
                  </span>
                </PDLButton>
              </div>
            </div>
          )}
          {isMobile && (
            <InputGroup>
              <DropdownButton
                variant="outline-secondary"
                title={renderSearchType()}
                id="input-group-dropdown-mobile"
                size="sm"
              >
                {Object.entries(SEARCH_TYPES)
                  .sort(({ order: a }, { order: b }) => a - b)
                  .map(([id, { title }]) => (
                    <Dropdown.Item
                      href="#"
                      key={`DD_ITEM_MOBILE_${title}`}
                      onClick={() => handleDDChange(id)}
                    >
                      {title}
                    </Dropdown.Item>
                  ))}
              </DropdownButton>
              <Form.Control
                type="text"
                placeholder={
                  (pageTitle && `Pesquisar ${pageTitle}`) || "Plataforma LEX"
                }
                value={queryValue || ""}
                onChange={handleInputChange}
                size="sm"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
              />
              <PDLButton
                variant="tertiary"
                className="gray px-2"
                onClick={handleSearch}
                size="sm"
              >
                <SearchSm />
              </PDLButton>
            </InputGroup>
          )}
        </>
      )}
    </div>
  );
};

export default OmniBar;
